import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import {
  CompanyRelations,
  OtherRelation,
  Owners,
  Representative,
  Society,
} from '../../interface/owners.interface';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { ServiceInfoClientService } from '../../service/service-info-client.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { UpdateOwnersComponent } from '../../modals/update-owners/update-owners.component';
import Swal from 'sweetalert2';
import { AuthService } from 'src/app/pages/authentication/service/auth.service';
import { ScoringIngeService } from '../../service/scoring-inge.service';
import { OwnersMinuteRequest } from '../../sub-page/minutes/interface/minute-detail';
import { DicomFormularioComponent } from '../../modals/dicom-formulario/dicom-formulario.component';
import { CmfFormComponent } from '../forms/cmf-form/cmf-form.component';
import { E } from '@angular/cdk/keycodes';

@Component({
  selector: 'app-partner-table',
  templateUrl: './partner-table.component.html',
  styleUrls: ['./partner-table.component.scss'],
})
export class PartnerTableComponent implements OnChanges {
  public existenSocios: boolean;
  public dataSourceOwners!: MatTableDataSource<Owners>;
  public dataSourceRepresentatives!: MatTableDataSource<Representative>;
  public dataSourceSocieties!: MatTableDataSource<Society>;
  @Input() receiveBoolean: boolean;
  public dataSourceOthers!: MatTableDataSource<OtherRelation>;
  public socios: Owners;
  public rutUrl: number;
  public mostrarColumna: boolean[];
  public deuda: number = 0;
  public dataSourceOwners2: CompanyRelations | undefined;
  public booleanFlag: boolean = false;
  public hasDicomPermission: boolean;
  public currentURL: string;
  public displayedColumnsOwners: string[] = [
    'fullRut',
    'name',
    'participation',
    'civilState',
    'age',
    'isAval',
    'isRL',
    'deudaDicom',
    'deudaSbif',
  ];

  public displayedColumnsRepresentatives: string[] = [
    'fullRut',
    'name',
    'role',
    'email',
    'phone',
    'deudaDicom',
    'deudaSbif',
  ];

  public displayedColumnsSocieties: string[] = [
    'fullRut',
    'name',
    'deudaDicom',
    'deudaSbif',
  ];

  public displayedColumnsOthers: string[] = [
    'fullRut',
    'name',
    'description',
    'deudaDicom',
    'deudaSbif',
  ];

  constructor(
    private serviceInfo: ServiceInfoClientService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private scoringIngeService: ScoringIngeService,
    private authService: AuthService
  ) {}
  
  openUrl(id) {
    window.open(this.currentURL + '=' + id);
  }
  ngOnInit() {
    this.route.queryParams.subscribe((params: any) => {
      const { client } = params;
      const rut = parseInt(client);
      this.rutUrl = parseInt(client);
      this.getOwners(rut);
    });
    this.currentURL = window.location.href.split('=')[0];
    this.hasDicomPermission = this.authService.ValidateUserPermission(
      'RequestOwnerPermissions'
    );
    this.hideRut();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['receiveBoolean']) {      
      if (this.rutUrl) {
        this.getOwners(this.rutUrl); // Llamar a getOwners con rutUrl actualizado
      }
    }
  }

  public getOwners(rut: number) {
    this.serviceInfo.getCompanyRelations(rut).subscribe((e) => {      
      this.dataSourceOwners2 = e;
      this.setDataSource(e);
      if (e.legalOwners.length == 0) {
        this.existenSocios = false;
      } else {
        this.existenSocios = true;
      }
    });
  }

  private setDataSource(dataSource: CompanyRelations) {
    this.dataSourceOwners = new MatTableDataSource<Owners>(
      dataSource.legalOwners
    );
    this.dataSourceSocieties = new MatTableDataSource<Society>(
      dataSource.societies
    );
    this.dataSourceRepresentatives = new MatTableDataSource<Representative>(
      dataSource.representatives
    );
    this.mostrarColumna = this.dataSourceRepresentatives.data.map((e) => {
      return e.companyId < 1000000000;
    });    
    this.dataSourceOthers = new MatTableDataSource<OtherRelation>(
      dataSource.others
    );
  }

  deleteOwners(id: number, nombre: string, tipo: string) {
    Swal.fire({
      titleText:
        '¿Deseas eliminar la relación de ' + tipo + ' con ' + nombre + '?',
      showCancelButton: true,
      heightAuto: false,
      showConfirmButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Confirmar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.serviceInfo.deleteOwner(id).subscribe({
          next: (res) => {
            Swal.fire({
              title: `Se ha eliminado exitosamente`,
              heightAuto: false,
              icon: 'success',
            }).then((result) => {
              if (result.isConfirmed) {
                this.getOwners(this.rutUrl);
              }
            });
          },
          error: (error) => {            
            Swal.fire({
              title: `Ocurrio un problema al eliminar la relación`,
              icon: 'error',
              heightAuto: false,
            });
          },
        });
      }
    });
  }

  updateInfo(dataOwners: any, relationType: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = 'container_form_debts';
    dataOwners.relationType = relationType;
    dataOwners.isNew = false;
    dialogConfig.data = dataOwners;    
    const dialogRef = this.dialog.open(UpdateOwnersComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((res: boolean) => {
      if (res) this.getOwners(this.rutUrl);
    });
  }

  addNew(relationType: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = 'container_form_debts';
    dialogConfig.data = {
      parentRut: this.rutUrl,
      relationType: relationType,
      isNew: true,
    };
    const dialogRef = this.dialog.open(UpdateOwnersComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((res: boolean) => {
      if (res) this.getOwners(this.rutUrl);
    });
  }

  public getDicomPartners() {
    if (!this.hasDicomPermission) {
      Swal.fire({
        title: 'Error',
        text: 'No posee los permisos necesarios para solicitar DICOM',
        icon: 'error',
        heightAuto: false,
        showConfirmButton: true,
        confirmButtonText: 'Cerrar',
      });
      return;
    }
    this.booleanFlag = true;
    if (this.dataSourceOwners2 != undefined) {
      var partners = this.dataSourceOwners2?.legalOwners.length ?? 0;
      var partnersCompleted = 0;
      for (let i = 0; i < partners; i++) {
        const rut = this.dataSourceOwners2[i]!.fullRut.replace('.', '').replace(
          '.',
          ''
        );
        this.scoringIngeService.getEquifaxReportScoring(rut).subscribe({
          next: (response) => {
            if (this.dataSourceOwners2 != undefined) {
              this.dataSourceOwners2[i].Dicom = response.totaL_DEBT_AMOUNT;
            }
            partnersCompleted = partnersCompleted + 1;
            this.booleanFlag = false;
            if (partnersCompleted == partners) this.getOwners(this.rutUrl);
            this.booleanFlag = false;
          },
          error(error) {            
          },
        });
      }
    }
  }
  public historialDicom: boolean = false;

  getDeudaEquifaxBD(rut: number) {
    this.scoringIngeService.getEquifaxReportBD(rut).subscribe((result) => {
      this.deuda = result?.deudaDicom;
    });
  }
  public formDicom(element: string) {    
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '50vw';
    dialogConfig.height = '450px';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.data = element;

    const dialogRef = this.dialog.open(DicomFormularioComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((res: boolean) => {
      this.getOwners(this.rutUrl);
      if (res) {
        this.getDeudaEquifaxBD(this.rutUrl);
      } else {
        this.getDeudaEquifaxBD(this.rutUrl);
      }
    });
  }

  public formSbif(element: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '70vw';
    dialogConfig.height = '450px';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.data = {
      rut: element.fullRut,
      isPartner: true,
      name: element.completeName,
    };

    const dialogRef = this.dialog.open(CmfFormComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((res: boolean) => {
      this.getOwners(this.rutUrl);
      if (res) {
        this.getDeudaEquifaxBD(this.rutUrl);
      } else {
        this.getDeudaEquifaxBD(this.rutUrl);
      }
    });
  }

  hideRut() {
    const algo = this.dataSourceRepresentatives?.data.some((e) => e.fullRut);    
  }
}
